<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item"><a :href="'/storyboard'">Storyboard</a></li>
      <li v-if="$route.params.id && storyboard" class="breadcrumb-item">
        <a :href="'/storyboard/' + $route.params.id">{{ storyboard.name }}</a>
      </li>
      <li v-if="$route.path.includes('storyboard/new')" class="breadcrumb-item">
        <a :href="'/storyboard/new'">New</a>
      </li>
      <li
        v-if="
          $route.params.id &&
          $route.path.includes('/edit') &&
          !$route.params.stageId &&
          !$route.params.stepId
        "
        class="breadcrumb-item"
      >
        <a :href="'/storyboard/' + $route.params.id + '/edit'">Edit</a>
      </li>
      <li
        v-if="$route.params.id && $route.path.includes('/plan')"
        class="breadcrumb-item"
      >
        <a :href="'/storyboard/' + $route.params.id + '/plan'">Set stages</a>
      </li>
      <!--
			<li v-if="$route.params.stageId && $route.path.includes('stage')" class="breadcrumb-item"><a :href="'/storyboard/' + $route.params.id + '/stage/' + $route.params.stageId">Stage</a></li>
            -->
      <li v-if="$route.params.stageId && stage" class="breadcrumb-item">
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId
          "
        >
          {{ stage.name }}
        </a>
      </li>
      <li
        v-if="
          $route.params.stageId &&
          $route.path.includes('edit') &&
          !$route.params.stepId
        "
        class="breadcrumb-item"
      >
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/edit'
          "
        >
          Edit
        </a>
      </li>
      <li
        v-if="$route.params.stageId && $route.path.includes('plan')"
        class="breadcrumb-item"
      >
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/plan'
          "
        >
          Set steps
        </a>
      </li>
      <!--
			<li v-if="$route.params.stepId" class="breadcrumb-item"><a :href="'/storyboard/' + $route.params.id + '/stage/' + $route.params.stageId + '/step' + $route.params.stepId">Step</a></li>
            -->
      <li v-if="$route.params.stepId && step" class="breadcrumb-item">
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/step' +
            $route.params.stepId
          "
        >
          {{ step.name }}
        </a>
      </li>
      <li
        v-if="$route.params.stepId && $route.path.includes('/edit')"
        class="breadcrumb-item"
      >
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/step/' +
            $route.params.stepId +
            '/edit'
          "
        >
          Edit
        </a>
      </li>
      <li v-if="$route.path.includes('stage/new')" class="breadcrumb-item">
        <a :href="'/storyboard/' + $route.params.id + '/stage/new'">New</a>
      </li>
      <li v-if="$route.path.includes('step/new')" class="breadcrumb-item">
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/step/new'
          "
        >
          Step
        </a>
      </li>
      <li v-if="$route.path.includes('step/new')" class="breadcrumb-item">
        <a
          :href="
            '/storyboard/' +
            $route.params.id +
            '/stage/' +
            $route.params.stageId +
            '/step/new'
          "
        >
          New
        </a>
      </li>
      <li v-if="$route.path.includes('search')" class="breadcrumb-item">
        <a :href="'/storyboard/search/storyboards'">Search</a>
      </li>
      <li
        v-if="$route.path.includes('search/storyboards')"
        class="breadcrumb-item"
      >
        <a :href="'/storyboard/search/storyboards'">Storyboards</a>
      </li>
      <li v-if="$route.path.includes('search/stages')" class="breadcrumb-item">
        <a :href="'/storyboard/search/stages'">Stages</a>
      </li>
      <li v-if="$route.path.includes('search/steps')" class="breadcrumb-item">
        <a :href="'/storyboard/search/steps'">Steps</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      Storyboards
      <small
        >Storyboard is your place for event design. Set up your planning
        framework. Add stages to storyboards. Add steps to stages.</small
      >
    </h1>
    <!-- end page-header -->
    <router-view
      v-bind:activeEvent="activeEvent"
      v-bind:storyboards="storyboards"
      v-bind:storyboard="storyboard"
      v-bind:stages="stages"
      v-bind:stage="stage"
      v-bind:steps="steps"
      v-bind:step="step"
      v-bind:scriptItems="scriptItems"
      v-bind:getStep="getStep"
      v-bind:removeImage="removeImage"
      v-bind:removeFile="removeFile"
      v-bind:deleteNoteCall="deleteNoteCall"
      v-bind:bulkDeleteStoryboards="bulkDeleteStoryboards"
      v-bind:bulkDeleteStages="bulkDeleteStages"
      v-bind:bulkDeleteSteps="bulkDeleteSteps"
      v-bind:bulkSetStageStoryboards="bulkSetStageStoryboards"
      v-bind:bulkSetStepStages="bulkSetStepStages"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { noteService } from '../services/note.service.js'
import { imageService } from '../services/image.service.js'
import { fileService } from '../services/file.service.js'

export default {
  name: 'Storyboard',
  computed: {
    ...mapState('storyboard', ['storyboards', 'storyboard']),
    ...mapState('stage', ['stages', 'stage']),
    ...mapState('step', ['steps', 'step']),
    ...mapState('scriptitem', ['scriptItems', 'scriptItem']),
    ...mapState('event', ['activeEvent'])
  },
  data() {
    return {
      storyboardsUpToDate: true,
      stagesUpToDate: true,
      stepsUpToDate: true
    }
  },
  methods: {
    ...mapActions('storyboard', [
      'getStoryboards',
      'getStoryboard',
      'createStoryboard',
      'updateStoryboard',
      'deleteStoryboard'
    ]),
    ...mapActions('stage', [
      'getStages',
      'getStage',
      'createStage',
      'updateStage',
      'deleteStage'
    ]),
    ...mapActions('step', [
      'getSteps',
      'getStep',
      'createStep',
      'updateStep',
      'deleteStep'
    ]),
    ...mapActions('scriptitem', ['getScriptItems', 'getScriptItem']),
    create(storyboardData, createAnother = false, redirect = true) {
      this.createStoryboard(storyboardData).then(() => {
        if (createAnother) {
          window.location.reload()
        } else {
          if (redirect) {
            this.$router.push('/storyboard')
          }
        }
      })
    },
    update(storyboardId, storyboardData) {
      this.updateStoryboard({ storyboardId, storyboardData })
      this.$router.push(`/storyboard/${storyboardId}`)
      this.getStoryboard(storyboardId)
    },
    delete(storyboardId) {
      this.deleteStoryboard(storyboardId)
      this.$router.push('/storyboard/search/storyboards')
      this.getStoryboards(this.activeEvent.id)
    },
    stageCreate(stageData, createAnother = false, redirect = true) {
      this.createStage(stageData).then(() => {
        if (createAnother) {
          window.location.reload()
        } else {
          if (redirect) {
            if (this.$route.params.id) {
              this.$router.push(`/storyboard/${this.$route.params.id}/plan`)
              this.getStoryboard(this.$route.params.id)
            } else {
              this.$router.push('/storyboard/search/stages')
            }
            this.getStoryboards(this.activeEvent.id)
          }
        }
        this.getStages(this.activeEvent.id)
      })
    },
    stageUpdate(stageId, stageData) {
      this.updateStage({ stageId, stageData })
      if (this.$route.params.id) {
        this.$router.push(
          `/storyboard/${this.$route.params.id}/stage/${stageId}`
        )
        this.getStage(stageId)
      } else {
        this.$router.push('/storyboard/search/stages')
      }
      this.getStoryboards(this.activeEvent.id)
      this.getStages(this.activeEvent.id)
    },
    stageEditStoryboard(stageId, stageData) {
      this.updateStage({ stageId, stageData })
      this.getStages(this.activeEvent.id)
      this.stagesUpToDate = false
    },
    stageDelete(stageId) {
      this.deleteStage(stageId)
      if (this.$route.params.id) {
        this.$router.push(`/storyboard/${this.$route.params.id}/plan`)
        this.getStoryboard(this.$route.params.id)
      } else {
        this.$router.push('/storyboard/search/stages')
      }
      this.getStoryboards(this.activeEvent.id)
      this.getStages(this.activeEvent.id)
    },
    stepCreate(stepData, createAnother = false, redirect = true) {
      this.createStep(stepData).then(() => {
        if (createAnother) {
          window.location.reload()
        } else {
          if (redirect) {
            if (this.$route.params.id && this.$route.params.stageId) {
              this.$router.push(
                `/storyboard/${this.$route.params.id}/stage/${this.$route.params.stageId}/plan`
              )
            } else {
              this.$router.push('/storyboard/search/steps')
            }
          }
        }
        this.getSteps(this.activeEvent.id)
      })
    },
    stepUpdate(stepId, stepData) {
      this.updateStep({ stepId, stepData })
      if (this.$route.params.id && this.$route.params.stageId) {
        this.$router.push(
          `/storyboard/${this.$route.params.id}/stage/${this.$route.params.stageId}/step/${stepId}`
        )
        this.getStep(stepId)
      } else {
        this.$router.push('/storyboard/search/steps')
      }
      this.getSteps(this.activeEvent.id)
    },
    stepEditStage(stepId, stepData) {
      this.updateStep({ stepId, stepData })
      this.getStages(this.activeEvent.id)
      this.getSteps(this.activeEvent.id)
      this.stagesUpToDate = false
      this.stepsUpToDate = false
    },
    stepDelete(stepId) {
      this.deleteStep(stepId)
      if (
        this.$route.params.id &&
        this.$route.params.stageId &&
        this.$route.params.stageId != 'null'
      ) {
        this.$router.push(
          `/storyboard/${this.$route.params.id}/stage/${this.$route.params.stageId}`
        )
      } else {
        this.$router.push('/storyboard/search/steps')
      }
      this.getSteps(this.activeEvent.id)
    },
    removeImage(imageId) {
      imageService.deleteImage(imageId)
    },
    removeFile(fileId) {
      fileService.deleteFile(fileId)
    },
    createNoteCall(noteData) {
      noteService.createNote(noteData)
    },
    submitNote(noteId, noteData) {
      noteService.updateNote(noteId, noteData)
    },
    deleteNoteCall(noteId) {
      noteService.deleteNote(noteId)
    },
    bulkDeleteStoryboards(sbId) {
      this.deleteStoryboard(sbId)
      this.getStoryboards(this.activeEvent.id)
      this.storyboardsUpToDate = false
    },
    bulkDeleteStages(stageId) {
      this.deleteStage(stageId)
      this.getStages(this.activeEvent.id)
      this.stagesUpToDate = false
    },
    bulkDeleteSteps(stepId) {
      this.deleteStep(stepId)
      this.getSteps(this.activeEvent.id)
      this.stepsUpToDate = false
    },
    bulkSetStageStoryboards(stageId, stageData) {
      this.updateStage({ stageId, stageData })
      this.getStages(this.activeEvent.id)
      this.stagesUpToDate = false
    },
    bulkSetStepStages(stepId, stepData) {
      this.updateStep({ stepId, stepData })
      this.getSteps(this.activeEvent.id)
      this.stepsUpToDate = false
    }
  },
  mounted() {
    this.getStoryboards(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getSteps(this.activeEvent.id)
    this.getScriptItems(this.activeEvent.id)
    if (this.$route.params.id != null && this.$route.params.id != 'null') {
      this.getStoryboard(this.$route.params.id)
    }
    if (
      this.$route.params.stageId != null &&
      this.$route.params.stageId != 'null'
    ) {
      this.getStage(this.$route.params.stageId)
    }
    if (
      this.$route.params.stepId != null &&
      this.$route.params.stepId != 'null'
    ) {
      this.getStep(this.$route.params.stepId)
    }
  },
  watch: {
    storyboards: function () {
      if (!this.storyboardsUpToDate) {
        this.getStoryboards(this.activeEvent.id)
        this.storyboardsUpToDate = true
      }
    },
    stages: function () {
      if (!this.stagesUpToDate) {
        this.getStages(this.activeEvent.id)
        this.stagesUpToDate = true
      }
    },
    steps: function () {
      if (!this.stepsUpToDate) {
        this.getSteps(this.activeEvent.id)
        this.stepsUpToDate = true
      }
    }
  }
}
</script>
